// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let IconV5 = require("../../../uikit/atoms/Icon/IconV5.bs.js");
let ButtonsV5 = require("../../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
let AuthSession = require("../../../utils/AuthSession.bs.js");
let Stdlib_Array = require("@rescript/runtime/lib/js/Stdlib_Array.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let ConversationPageSelectedConversationMatches_conversation_graphql = require("../../../__generated__/ConversationPageSelectedConversationMatches_conversation_graphql.bs.js");
let ConversationPageSelectedConversationMatchesBuyerMatches_match_graphql = require("../../../__generated__/ConversationPageSelectedConversationMatchesBuyerMatches_match_graphql.bs.js");
let ConversationPageSelectedConversationMatchesRenterMatches_match_graphql = require("../../../__generated__/ConversationPageSelectedConversationMatchesRenterMatches_match_graphql.bs.js");
let ConversationPageSelectedConversationMatchesSellerMatches_match_graphql = require("../../../__generated__/ConversationPageSelectedConversationMatchesSellerMatches_match_graphql.bs.js");
let ConversationPageSelectedConversationMatchesRentalOwnerMatches_match_graphql = require("../../../__generated__/ConversationPageSelectedConversationMatchesRentalOwnerMatches_match_graphql.bs.js");

let convertFragment = ConversationPageSelectedConversationMatchesBuyerMatches_match_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, ConversationPageSelectedConversationMatchesBuyerMatches_match_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(ConversationPageSelectedConversationMatchesBuyerMatches_match_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(fRef) : undefined, ConversationPageSelectedConversationMatchesBuyerMatches_match_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(ConversationPageSelectedConversationMatchesBuyerMatches_match_graphql.node, convertFragment, fRef);
}

let MatchFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function ConversationPageSelectedConversationMatches$BuyerMatches(props) {
  let matches = RescriptRelay_Fragment.useFragment(ConversationPageSelectedConversationMatchesBuyerMatches_match_graphql.node, convertFragment, props.matches);
  return Stdlib_Array.keepSome(matches).map(match => {
    let match$1 = match.source.client;
    let clientId = match$1.id;
    let match$2 = match.source.priceRange;
    return JsxRuntime.jsxs("div", {
      children: [
        JsxRuntime.jsx(ButtonsV5.Link.make, {
          href: "/my_clients/" + clientId,
          children: match$1.displayName
        }),
        ", ",
        JsxRuntime.jsx("div", {
          children: match$2.minPrice.formatted + " - " + match$2.maxPrice.formatted,
          className: "text-tan-gold"
        })
      ],
      className: "flex flex-row space-x-1 flex-wrap"
    }, clientId);
  });
}

let BuyerMatches = {
  MatchFragment: MatchFragment,
  make: ConversationPageSelectedConversationMatches$BuyerMatches
};

let convertFragment$1 = ConversationPageSelectedConversationMatchesRenterMatches_match_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, ConversationPageSelectedConversationMatchesRenterMatches_match_graphql.node, convertFragment$1, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(ConversationPageSelectedConversationMatchesRenterMatches_match_graphql.node, convertFragment$1, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(fRef) : undefined, ConversationPageSelectedConversationMatchesRenterMatches_match_graphql.node, convertFragment$1);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(ConversationPageSelectedConversationMatchesRenterMatches_match_graphql.node, convertFragment$1, fRef);
}

let MatchFragment$1 = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  use: use$1,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1
};

function ConversationPageSelectedConversationMatches$RenterMatches(props) {
  let matches = RescriptRelay_Fragment.useFragment(ConversationPageSelectedConversationMatchesRenterMatches_match_graphql.node, convertFragment$1, props.matches);
  return Stdlib_Array.keepSome(matches).map(match => {
    let match$1 = match.source.client;
    let clientId = match$1.id;
    let match$2 = match.source.priceRange;
    return JsxRuntime.jsxs("div", {
      children: [
        JsxRuntime.jsx(ButtonsV5.Link.make, {
          href: "/my_clients/" + clientId,
          children: match$1.displayName
        }),
        ", ",
        JsxRuntime.jsx("div", {
          children: match$2.minPrice.formatted + " - " + match$2.maxPrice.formatted + "/month",
          className: "text-tan-gold"
        })
      ],
      className: "flex flex-row space-x-1 flex-wrap"
    }, clientId);
  });
}

let RenterMatches = {
  MatchFragment: MatchFragment$1,
  make: ConversationPageSelectedConversationMatches$RenterMatches
};

let convertFragment$2 = ConversationPageSelectedConversationMatchesSellerMatches_match_graphql.Internal.convertFragment;

function waitForFragmentData$2(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, ConversationPageSelectedConversationMatchesSellerMatches_match_graphql.node, convertFragment$2, fRef);
}

function use$2(fRef) {
  return RescriptRelay_Fragment.useFragment(ConversationPageSelectedConversationMatchesSellerMatches_match_graphql.node, convertFragment$2, fRef);
}

function useOpt$2(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(fRef) : undefined, ConversationPageSelectedConversationMatchesSellerMatches_match_graphql.node, convertFragment$2);
}

function readResolverFragment$2(fRef) {
  return RescriptRelay_Fragment.read(ConversationPageSelectedConversationMatchesSellerMatches_match_graphql.node, convertFragment$2, fRef);
}

let MatchFragment$2 = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$2,
  waitForFragmentData: waitForFragmentData$2,
  use: use$2,
  useOpt: useOpt$2,
  readResolverFragment: readResolverFragment$2
};

function ConversationPageSelectedConversationMatches$SellerMatchers(props) {
  let matches = RescriptRelay_Fragment.useFragment(ConversationPageSelectedConversationMatchesSellerMatches_match_graphql.node, convertFragment$2, props.matches);
  return Stdlib_Array.keepSome(matches).map(match => {
    let match$1 = match.source.client;
    let clientId = match$1.id;
    let match$2 = match.source.propertyLocation;
    let tmp;
    if (match$2 !== undefined) {
      switch (match$2.__typename) {
        case "PropertyLocationWithHiddenAddress" :
          tmp = match$2.locationDisplay;
          break;
        case "PropertyLocationWithVisibleAddress" :
          tmp = match$2.locationDisplay;
          break;
        case "__unselected" :
          tmp = undefined;
          break;
      }
    } else {
      tmp = undefined;
    }
    let match$3 = match.source.price;
    let tmp$1;
    tmp$1 = match$3.__typename === "ExactPrice" ? JsxRuntime.jsx("div", {
        children: match$3.price.formatted,
        className: "text-tan-gold"
      }) : null;
    return JsxRuntime.jsxs("div", {
      children: [
        JsxRuntime.jsx(ButtonsV5.Link.make, {
          href: "/my_clients/" + clientId,
          children: match$1.displayName
        }),
        ", ",
        " " + Stdlib_Option.getOr(tmp, ""),
        tmp$1
      ],
      className: "flex flex-row space-x-1 flex-wrap"
    }, clientId);
  });
}

let SellerMatchers = {
  MatchFragment: MatchFragment$2,
  make: ConversationPageSelectedConversationMatches$SellerMatchers
};

let convertFragment$3 = ConversationPageSelectedConversationMatchesRentalOwnerMatches_match_graphql.Internal.convertFragment;

function waitForFragmentData$3(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, ConversationPageSelectedConversationMatchesRentalOwnerMatches_match_graphql.node, convertFragment$3, fRef);
}

function use$3(fRef) {
  return RescriptRelay_Fragment.useFragment(ConversationPageSelectedConversationMatchesRentalOwnerMatches_match_graphql.node, convertFragment$3, fRef);
}

function useOpt$3(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(fRef) : undefined, ConversationPageSelectedConversationMatchesRentalOwnerMatches_match_graphql.node, convertFragment$3);
}

function readResolverFragment$3(fRef) {
  return RescriptRelay_Fragment.read(ConversationPageSelectedConversationMatchesRentalOwnerMatches_match_graphql.node, convertFragment$3, fRef);
}

let MatchFragment$3 = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$3,
  waitForFragmentData: waitForFragmentData$3,
  use: use$3,
  useOpt: useOpt$3,
  readResolverFragment: readResolverFragment$3
};

function ConversationPageSelectedConversationMatches$RentalOwnerMatches(props) {
  let matches = RescriptRelay_Fragment.useFragment(ConversationPageSelectedConversationMatchesRentalOwnerMatches_match_graphql.node, convertFragment$3, props.matches);
  return Stdlib_Array.filterMap(Stdlib_Array.keepSome(matches), match => {
    let clientId = match.source.client.id;
    let name = match.source.client.displayName;
    let match$1 = match.source.propertyLocation;
    let tmp;
    if (match$1 !== undefined) {
      switch (match$1.__typename) {
        case "PropertyLocationWithHiddenAddress" :
        case "PropertyLocationWithVisibleAddress" :
          tmp = match$1.locationDisplay;
          break;
        case "__unselected" :
          tmp = undefined;
          break;
      }
    } else {
      tmp = undefined;
    }
    let match$2 = match.source.price;
    let tmp$1;
    tmp$1 = match$2.__typename === "ExactPrice" ? JsxRuntime.jsx("div", {
        children: match$2.price.formatted + "/month",
        className: "text-tan-gold"
      }) : null;
    return JsxRuntime.jsxs("div", {
      children: [
        JsxRuntime.jsx(ButtonsV5.Link.make, {
          href: "/my_clients/" + clientId,
          children: name
        }),
        ", ",
        " " + Stdlib_Option.getOr(tmp, ""),
        tmp$1
      ],
      className: "flex flex-row space-x-1 flex-wrap"
    }, clientId);
  });
}

let RentalOwnerMatches = {
  MatchFragment: MatchFragment$3,
  make: ConversationPageSelectedConversationMatches$RentalOwnerMatches
};

let convertFragment$4 = ConversationPageSelectedConversationMatches_conversation_graphql.Internal.convertFragment;

function waitForFragmentData$4(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, ConversationPageSelectedConversationMatches_conversation_graphql.node, convertFragment$4, fRef);
}

function use$4(fRef) {
  return RescriptRelay_Fragment.useFragment(ConversationPageSelectedConversationMatches_conversation_graphql.node, convertFragment$4, fRef);
}

function useOpt$4(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, ConversationPageSelectedConversationMatches_conversation_graphql.node, convertFragment$4);
}

function readResolverFragment$4(fRef) {
  return RescriptRelay_Fragment.read(ConversationPageSelectedConversationMatches_conversation_graphql.node, convertFragment$4, fRef);
}

let ConversationFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$4,
  waitForFragmentData: waitForFragmentData$4,
  use: use$4,
  useOpt: useOpt$4,
  readResolverFragment: readResolverFragment$4
};

function ConversationPageSelectedConversationMatches(props) {
  let conversationContext = RescriptRelay_Fragment.useFragment(ConversationPageSelectedConversationMatches_conversation_graphql.node, convertFragment$4, props.conversationContext);
  let ownerAgentId;
  switch (conversationContext.__typename) {
    case "AvailableConversationContext" :
      let conversationContext$1 = conversationContext.context;
      if (conversationContext$1 !== undefined) {
        switch (conversationContext$1.__typename) {
          case "ForSalePropertyV5" :
            let match = conversationContext$1.agentV2;
            if (match !== undefined && match.__typename === "VisibleForSalePropertyAgent") {
              let match$1 = match.agent;
              ownerAgentId = match$1 !== undefined ? match$1.id : undefined;
            } else {
              ownerAgentId = undefined;
            }
            break;
          case "__unselected" :
            ownerAgentId = undefined;
            break;
          default:
            let match$2 = conversationContext$1.agent;
            ownerAgentId = match$2 !== undefined ? match$2.id : undefined;
        }
      } else {
        ownerAgentId = undefined;
      }
      break;
    case "RemovedConversationContext" :
      let match$3 = conversationContext.agent;
      ownerAgentId = match$3 !== undefined ? match$3.id : undefined;
      break;
    case "__unselected" :
      ownerAgentId = undefined;
      break;
  }
  let agentIsOwner = AuthSession.useAgentIsCurrentUser(ownerAgentId);
  if (agentIsOwner) {
    return null;
  }
  switch (conversationContext.__typename) {
    case "AvailableConversationContext" :
      let conversationContext$2 = conversationContext.context;
      if (conversationContext$2 === undefined) {
        return null;
      }
      let title;
      switch (conversationContext$2.__typename) {
        case "BuyerNeedV5" :
          let match$4 = conversationContext$2.currentUsersMatches;
          if (match$4 !== undefined) {
            let totalCount = match$4.totalCount;
            title = totalCount !== 0 ? (
                totalCount !== 1 ? "Your matching active sellers:" : "Your matching active seller:"
              ) : "You have no matching active sellers";
          } else {
            title = "There was a problem loading matches";
          }
          break;
        case "ForSalePropertyV5" :
          let match$5 = conversationContext$2.currentUsersMatches;
          if (match$5 !== undefined) {
            let totalCount$1 = match$5.totalCount;
            title = totalCount$1 !== 0 ? (
                totalCount$1 !== 1 ? "Your matching active buyers:" : "Your matching active buyer:"
              ) : "You have no matching active buyers";
          } else {
            title = "There was a problem loading matches";
          }
          break;
        case "RentalNeedV5" :
          let match$6 = conversationContext$2.currentUsersMatches;
          if (match$6 !== undefined) {
            let totalCount$2 = match$6.totalCount;
            title = totalCount$2 !== 0 ? (
                totalCount$2 !== 1 ? "Your matching active rental owners:" : "Your matching active rental owner:"
              ) : "You have no matching active rental owners";
          } else {
            title = "There was a problem loading matches";
          }
          break;
        case "RentalPropertyV5" :
          let match$7 = conversationContext$2.currentUsersMatches;
          if (match$7 !== undefined) {
            let totalCount$3 = match$7.totalCount;
            title = totalCount$3 !== 0 ? (
                totalCount$3 !== 1 ? "Your matching active renters:" : "Your matching active renter:"
              ) : "You have no matching active renters";
          } else {
            title = "There was a problem loading matches";
          }
          break;
        case "DevelopmentProject" :
        case "DevelopmentProjectSampleUnit" :
        case "__unselected" :
          title = undefined;
          break;
      }
      if (title === undefined) {
        return null;
      }
      let tmp;
      switch (conversationContext$2.__typename) {
        case "BuyerNeedV5" :
          let match$8 = conversationContext$2.currentUsersMatches;
          tmp = match$8 !== undefined ? JsxRuntime.jsx(ConversationPageSelectedConversationMatches$SellerMatchers, {
              matches: Stdlib_Array.keepSome(Stdlib_Option.getOr(match$8.edges, [])).map(e => e.node.fragmentRefs)
            }) : null;
          break;
        case "ForSalePropertyV5" :
          let match$9 = conversationContext$2.currentUsersMatches;
          tmp = match$9 !== undefined ? JsxRuntime.jsx(ConversationPageSelectedConversationMatches$BuyerMatches, {
              matches: Stdlib_Array.keepSome(Stdlib_Option.getOr(match$9.edges, [])).map(e => e.node.fragmentRefs)
            }) : null;
          break;
        case "RentalNeedV5" :
          let match$10 = conversationContext$2.currentUsersMatches;
          tmp = match$10 !== undefined ? JsxRuntime.jsx(ConversationPageSelectedConversationMatches$RentalOwnerMatches, {
              matches: Stdlib_Array.keepSome(Stdlib_Option.getOr(match$10.edges, [])).map(e => e.node.fragmentRefs)
            }) : null;
          break;
        case "RentalPropertyV5" :
          let match$11 = conversationContext$2.currentUsersMatches;
          tmp = match$11 !== undefined ? JsxRuntime.jsx(ConversationPageSelectedConversationMatches$RenterMatches, {
              matches: Stdlib_Array.keepSome(Stdlib_Option.getOr(match$11.edges, [])).map(e => e.node.fragmentRefs)
            }) : null;
          break;
        default:
          tmp = null;
      }
      return JsxRuntime.jsx("div", {
        children: JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx(IconV5.make, {
                  icon: "lock",
                  className: "mr-1"
                }),
                "Only visible to you:"
              ],
              className: "flex flex-row space-x-2 text-gray-600"
            }),
            JsxRuntime.jsx("div", {
              children: title,
              className: "font-bold"
            }),
            JsxRuntime.jsx("div", {
              children: tmp,
              className: "flex flex-col gap-2"
            })
          ],
          className: "border rounded-md p-4 flex flex-col space-y-4"
        }),
        className: "mt-6"
      });
    case "RemovedConversationContext" :
    case "__unselected" :
      return null;
  }
}

let make = ConversationPageSelectedConversationMatches;

exports.BuyerMatches = BuyerMatches;
exports.RenterMatches = RenterMatches;
exports.SellerMatchers = SellerMatchers;
exports.RentalOwnerMatches = RentalOwnerMatches;
exports.ConversationFragment = ConversationFragment;
exports.make = make;
/* IconV5 Not a pure module */
